import { Link } from 'react-router-dom';
const logo = "https://storage.googleapis.com/connct-cba18.firebasestorage.app/frontend-assets/Conncct-logo.png";

type LogoProps = {
  className?: string;
  alt?: string;
  to?: string;
};

export default function Logo({ className = '', alt = 'Conncct', to = '/' }: LogoProps) {
  return (
    <Link to={to} className="inline-block">
      <img src={logo} alt={alt} className={className} />
    </Link>
  );
}
